import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

import Login from './components/login';
import Dashboard from './components/dashboard';
import ErrorBoundary from './components/ErrorBoundary';
import DoctorAppointments from './components/Doctor/DoctorAppointments';
import PharmacyAppointments from './components/Pharmacy/PharmacyAppointments';
import './App.css';
import useAuthCheck from './hooks/useAuthCheck';
import { patchFetchWithAuth } from './hooks/fetchWithAuth';

// Utility function to check if user is authenticated
const isAuthenticated = () => {
  const adminid = Cookies.get('adminid') || localStorage.getItem('adminid');
  const token = Cookies.get('token') || localStorage.getItem('token');
  return Boolean(adminid && token && String(adminid).trim() !== '' && String(token).trim() !== '');
};

// ProtectedRoute component
const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/" replace />;
};
patchFetchWithAuth();
// AppRoutes component (inside Router)
const AppRoutes = () => {
  useAuthCheck(); // ✅ now safely inside Router

  return (
    <Routes>
      {/* Root route */}
      <Route
        path="/"
        element={isAuthenticated() ? <Navigate to="/dashboard" replace /> : <Login />}
      />

      {/* Dashboard */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* Doctor appointments */}
      <Route
        path="/doctor-appointments/:doctorId/:clinicId"
        element={
          <ProtectedRoute>
            <DoctorAppointments />
          </ProtectedRoute>
        }
      />

      {/* Pharmacy appointments */}
      <Route
        path="/pharmacy-appointments/:pharmacyId"
        element={
          <ProtectedRoute>
            <PharmacyAppointments />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

const App = () => {
  return (
    <ErrorBoundary>
      <Router>
        <AppRoutes />
      </Router>
    </ErrorBoundary>
  );
};

export default App;
